
import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Image, Grid, Dropdown, List, Label, Popup, Checkbox, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { API_URL } from '../App.js';
import axios from 'axios';
import {retrieveSubjectObject, nounoptions1, nounoptions2, nounoptions3, nounoptionsmodalis, options1, options2, options3, verbPostbases, nounPostbases} from './constants/constants.js'
import {postbasesEndingsUnderlying} from './constants/underlying.js'
import palette from 'google-palette';
import shuffle from 'shuffle-array';
import { TagColors } from './HomeHelper.js';
import * as Scroll from 'react-scroll';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactGA from "react-ga4";
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { far } from '@fortawesome/free-regular-svg-icons'
// import { fab } from '@fortawesome/free-brands-svg-icons'

ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

let manualPictures = []


class Resources extends Component {
	constructor(props) {
		// console.log(props)
		super(props);
		this.state = {
      featuredVideoIDs:['2','1','3'],
      featuredVideoIDs2:[],
      featuredZooms:['2','1','3'],
			// history: props.location.state === undefined ? [] : props.location.state.history,
			// from: props.location.state === undefined ? '' : props.location.state.from,
		}	   
		scroll.scrollTo(0);

	}

	repeatAudio(audio, event, data) {
	  if (!this.state.playingAudio) {

	    let sound = new Audio(API_URL + "/tlingitaudiolibrary/" +  audio);
	    this.setState({playingAudio: true});

	    sound.play()

	    sound.onended=()=>{
	      this.setState({playingAudio: false});
	    }
	  }
	}

// <link rel="preconnect" href="https://fonts.googleapis.com">
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="">
// <link href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&amp;display=swap" rel="stylesheet">
// [leaflet-map address="Juneau, Alaska" zoom="10" height="700" tileurl=https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.jpg zoomcontrol dragging scrollwheel gesture doubleclickzoom]
// [leaflet-geojson src="https://gist.githubusercontent.com/lonnystrunk/fd99e52cfb86c1ebe207506bad898119/raw/fffe18df77df9c39af18a272d708b905571d7c92/placenames.geojson"]
	// <span style="font-family:'Raleway'"><b>{name}</b> #{id}
	// {translation}
	// {location}</span>
// [/leaflet-geojson]
// [geojsonmarker svg property=marker-color 
	// icondefault=#B5B5B5 
	// iconprops="#0056d6,#6EE5FF,#2EA524,#890101,#6F4413,#7c7c7c" 
	// shape=circle 
	// icon=fa-solid 
	// prefix=fa-circle 
	// disableClusteringAtZoom=4  
	// values="#0056d6,#00c7fc,#4f7a28,#555555,#d95000,#b5b5b5" 
	// groups="Water,Ice,Land,Settlement,Trail,Unsure" 
	// visible=1,1,1,1,1,0]
// [fullscreen][zoomhomemap !fit]


	render() {

    let showLargerTable = window.innerWidth >= 480
    return (
      <div style={{fontFamily:customFontFam3}} className='home'>
      <Grid textAlign='center'>
    <div style={{maxWidth:800,border:'1px solid #E3E3E3',marginTop:'14px'}}>


      <Grid textAlign='center'>
        <Image style={{'fontSize': '2.3em',cursor:'pointer',padding:0}} src={"/newbanner.jpeg"}/>  
      {/*<Grid.Row style={{paddingTop:(largerInnerWidth ? 10: 5)}}>*/}
      <Grid.Row style={{padding:5}}>
        <Grid.Column style={{ maxWidth: 860, padding: 10,marginLeft:10,}} textAlign='left'>
          {/*<Button onClick={()=>{this.props.history.goBack()}} basic style={{paddingLeft:'10px',paddingRight:'15px',marginLeft:'3px'}} icon='left chevron' content='Back to Language Resources' />*/}

            <Link to={{pathname: "/"}} >
              <Button basic style={{fontSize:'15px',paddingLeft:'10px',paddingRight:'15px',marginLeft:'3px'}} icon='left chevron' content='Back to Homepage' />
            </Link>

        </Grid.Column>
      </Grid.Row>
    </Grid>


                  
          {/*
          <Grid style={{fontFamily:customTitleFontFam}}>

          {window.innerWidth < 480 ?
          <Grid.Row columns={2}>
              <Grid.Column style={{display:'flex',borderBottomLeftRadius:'8px',borderBottomRightRadius:'8px',alignItems:'center',marginLeft:14,marginRight:14,backgroundColor:'black'}} width={16}>
              <div style={{lineHeight:'26px',marginTop:'5px',marginBottom:'5px'}}>
              <div onClick={this.resetAll} style={{ color: 'white', fontSize:'13pt', fontWeight:'600', cursor:'pointer'}}>Haa Shuká Yóo X̲'atángi (Dictionary)</div>
              <div style={{color:'white',fontStyle:'italic',fontSize:'12pt',paddingBottom:'1px'}}>Language of our ancestors before and after</div>
              </div>
            </Grid.Column>
          </Grid.Row>
            :
          (this.state.logoup  ?
          <Grid.Row style={{margin:10}} columns={2}>
            <Grid.Column width={3}>
            <Image onClick={this.resetAll} style={{'fontSize': '2.3em',cursor:'pointer'}} src={"/image000001.jpeg"}/>          
            </Grid.Column>
              <Grid.Column style={{display:'flex',alignItems:'center'}} width={13}>
              <div style={{lineHeight:'30px'}}>
              <div onClick={this.resetAll} style={{ color: 'black', fontSize:'17pt', fontWeight:'500', cursor:'pointer'}}>Dictionary of Tlingit (In-Development)</div>
              </div>
            </Grid.Column>
          </Grid.Row>
          :
          <Grid.Row columns={2}>
              <Grid.Column style={{display:'flex',borderBottomLeftRadius:'8px',borderBottomRightRadius:'8px',alignItems:'center',marginLeft:14,marginRight:14,paddingBottom:'2px',paddingTop:'2px',marginBottom:'4px',backgroundColor:'black'}} width={16}>
              <div style={{lineHeight:'34px'}}>
              <div onClick={this.resetAll} style={{ color: 'white', fontSize:'17pt', fontWeight:'500', cursor:'pointer'}}>Haa Shuká Yóo X̲'atángi (Dictionary of Tlingit)</div>
              <div style={{color:'white',fontStyle:'italic',fontSize:'15pt',paddingBottom:'1px'}}>Language of our ancestors before and after</div>
              {false ?
              <div style={{color:'white',fontStyle:'italic',fontSize:'11pt',fontWeight:'350',lineHeight:'15px',paddingBottom:'13px',paddingTop:'7px'}}>This website is dedicated in loving memory to Satóokʼ (Linda Belarde), noble woman, lifelong learner of the Tlingit language and source of friendship and encouragement to all.</div>
              :null}
              </div>
            </Grid.Column>
          </Grid.Row>
          )
          }
        </Grid>*/}
        <div className='yugtatun'>Website Modules</div>

        <div style={{display:'flex',justifyContent:'center',flexDirection:'row',flexWrap:'wrap',maxWidth:'820px',marginLeft:'auto',marginRight:'auto'}}>

{/*          <div className='categoryButton' style={{margin:'15px'}}>
            <Link to={{pathname: '/dialogues/1'}}>
              <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'95%',borderRadius:'10px'}}>
                <div style={{fontWeight:'600'}}>{'Dialogue Lessons'}</div>
                <div>{" by Koodéik' and Lyanwudig̲aat"}</div>
              </div>
              <LazyLoadImage effect='opacity' width={'200px'} height={'250px'} style={{borderRadius:'10px',border:"1px solid #f3f3f3"}} src={'dialoguesscreenshot2.png'} />
            </Link>
          </div>*/}

          <div className='categoryButton' style={{margin:'15px'}}>
            <Link to={{pathname: '/phrasebook/1'}}>
              <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'90%',borderRadius:'10px'}}>
                <div style={{fontWeight:'600'}}>{'Lingít X̲’éináx̲ Sá!'}</div>
                <div>{'Say It in Tlingit! Phrasebook'}</div>
              </div>
              <LazyLoadImage effect='opacity' width={'200px'} height={'250px'} style={{borderRadius:'10px'}} src={'sayitintlingit.jpg'} />
            </Link>
          </div>

          <div className='categoryButton' style={{margin:'15px'}}>
            <Link to={{pathname: '/dialogues/1'}}>
              <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'95%',borderRadius:'10px'}}>
                <div style={{fontWeight:'600'}}>{'Dialogue Lessons'}</div>
                <div>{" by Koodéik' and Lyanwudig̲aat"}</div>
              </div>
              <LazyLoadImage effect='opacity' width={'200px'} height={'250px'} style={{borderRadius:'10px',border:"1px solid #f3f3f3"}} src={'dialoguesscreenshot2.png'} />
            </Link>
          </div>

          <div className='categoryButton' style={{margin:'15px'}}>
            <Link to={{pathname: '/tlingitphrases/1'}}>
              <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'95%',borderRadius:'10px'}}>
                <div style={{fontWeight:'600'}}>{'Tlingit Phrases'}</div>
                <div>{" DIA language sessions"}</div>
              </div>
              <LazyLoadImage effect='opacity' width={'200px'} height={'250px'} style={{borderRadius:'10px',border:"1px solid #f3f3f3"}} src={'oldschool.png'} />
            </Link>
          </div>

        </div>


        <Divider style={{padding:0,marginTop:30,paddingBottom:20}} />


{/*          <div style={{display:'flex',justifyContent:'center',flexDirection:'row',flexWrap:'wrap',maxWidth:'820px',marginLeft:'auto',marginRight:'auto'}}>
            {this.state.featuredVideoIDs.map((j) => (
              j in this.props.videoList ?
              <div className='categoryButton' style={{margin:'20px'}}>
                <Link to={{pathname: '/video/'+j}}>
                  <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'90%',borderRadius:'10px'}}>
                    {this.props.videoList[j]['video-title'].includes(' - ') ?
                    <div>
                    <div style={{fontWeight:'600'}}>{this.props.videoList[j]['video-title'].split(' - ')[0]}</div>
                    <div>{this.props.videoList[j]['video-title'].split(' - ')[1]}</div>
                    </div>
                    :
                    <div style={{fontWeight:'600'}}>{this.props.videoList[j]['video-title']}</div>
                    }

                  </div>
                  <LazyLoadImage effect='opacity' width={'310px'} height={'190px'} style={{borderRadius:'10px'}} src={(manualPictures.includes(j) ? j+'.png' : 'https://img.youtube.com/vi/'+this.props.videoList[j]['youtube-url']+'/maxresdefault.jpg')} />
                </Link>
              </div>
              :
              null
            ))}




        {this.state.showMoreVideos ?
          Object.keys(this.props.videoList).map((j) => (
            this.props.videoList[j]['category'] != 'Zoom Session' && !(this.state.featuredVideoIDs.includes(j)) ?
            <div className='categoryButton' style={{margin:'20px'}}>
              <Link to={{pathname: '/video/'+j}}>
                <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'90%',borderRadius:'10px'}}>
                  <div style={{fontWeight:'600'}}>{this.props.videoList[j]['title']}</div>
                  <div>{this.props.videoList[j]['short-summary']}</div>
                </div>
                <LazyLoadImage effect='opacity' width={'310px'} height={'190px'} style={{borderRadius:'10px'}} src={(manualPictures.includes(j) ? j+'.png' : 'https://img.youtube.com/vi/'+j+'/maxresdefault.jpg')} />
              </Link>
            </div>
            :
            null
          ))
          :
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',margin:'24px'}}>
              <Button basic style={{fontSize:16,display:'flex',flexDirection:'row',alignItems:'center'}} onClick={()=>{this.setState({showMoreVideos:true})}}>
                <span style={{fontSize:16,lineHeight:'20px',marginRight:'10px'}}>{"See More Videos"}</span>
                <Icon style={{float:'right',fontSize:16}} name='chevron down' />
              </Button> 
          </div>
        }

          </div>*/}
          


        <div className='yugtatun'>Tlingit Audio Storytelling or Tlingit Elder Knowledge</div>

        <div className='yugtatunsub'>Featured Sessions</div>

          <Grid textAlign='center'>
            <Grid.Row style={{paddingTop:0,marginBottom:20}}>
              <Grid.Column style={{  maxWidth: 660, padding: 0, fontFamily:customFontFam }} textAlign='left'>
                <div style={{display:'flex',flexWrap:'wrap',fontSize:'16px',justifyContent:'center'}}>
                  {this.state.featuredZooms.map((y,yindex)=>
                    (y in this.props.videoList ?
                    (showLargerTable ? 
                      <Grid style={{marginTop:'20px'}}>
                        <Grid.Row columns={2} style={{alignItems:'center',margin:'6px 10px'}}>
                          <Grid.Column width={6}>
                          <Link to={{pathname: '/video/'+y}}>
                            <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+this.props.videoList[y]['youtube-url']+'/maxresdefault.jpg'} />
                            {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                          </Link>
                          </Grid.Column>
                          <Grid.Column width={10}>
                            <Link style={{color:'#000000DE'}} to={{pathname: '/video/'+y}}>
                              {this.props.videoList[y]['video-title'].includes(' - ') ?
                              <div>
                              <div style={{fontWeight:'600'}}>{this.props.videoList[y]['video-title'].split(' - ')[0]}</div>
                              <div style={{fontStyle:'italic'}}>{this.props.videoList[y]['video-title'].split(' - ')[1]}</div>
                              </div>
                              :
                              <div style={{fontWeight:'600'}}>{this.props.videoList[y]['video-title']}</div>
                              }
                            </Link>
                            <div style={{color:'#00000099',fontSize:'14px',marginTop:'6px',marginBottom:'5px'}}>{this.props.videoList[y]['date']}</div>
                            <div style={{fontSize:'14px',lineHeight:'17px'}}>{this.props.videoList[y]['short-summary']}</div>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      :
                      <Grid style={{marginTop:'20px'}}>
                        <Grid.Row columns={2} style={{alignItems:'center',margin:'6px 10px'}}>
                          <Grid.Column width={7}>
                          <Link to={{pathname: '/video/'+y}}>
                            <Image style={{margin:"0px 10px",borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+this.props.videoList[y]['youtube-url']+'/maxresdefault.jpg'} />
                            {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                          </Link>
                          </Grid.Column>
                          <Grid.Column width={9}>
                            <Link style={{color:'#000000DE'}} to={{pathname: '/video/'+y}}>
                              {this.props.videoList[y]['video-title'].includes(' - ') ?
                              <div>
                              <div style={{fontWeight:'600'}}>{this.props.videoList[y]['video-title'].split(' - ')[0]}</div>
                              </div>
                              :
                              <div style={{fontWeight:'600'}}>{this.props.videoList[y]['video-title']}</div>
                              }
                            </Link>
                          <div style={{color:'#00000099',fontSize:'14px',marginTop:'6px',marginBottom:'5px'}}>{this.props.videoList[y]['date']}</div>
                          <div style={{fontSize:'14px',lineHeight:'17px'}}>{this.props.videoList[y]['short-summary']}</div>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    )
                    :
                    null
                    )
                    )}
                   </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>



{/*           <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',margin:'24px'}}>
              <Link to={{pathname: '/recorder/'}}>
                    <Button basic style={{fontSize:16,display:'flex',flexDirection:'row',alignItems:'center'}}>
                      <span style={{fontSize:16,lineHeight:'20px'}}>{"Recording Tools"}</span>
                      <Icon style={{float:'right',fontSize:16}} name='chevron right' />
                    </Button>             
                  </Link>
                </div>*/}

        <div style={{display:'flex',justifyContent:'flex-start',textAlign:'center',marginTop:'30px',marginBottom:'20px'}}>

          <div style={{paddingTop:'10px',paddingBottom:'30px',paddingLeft:'8px'}}>
          <Link to={{pathname: '/report'}}>
            <Icon style={{color:'#a9a9a9',}} name='exclamation circle' />
            <span style={{fontSize:'14px',color:'#9d9d9d',fontWeight:'400',lineHeight:'23px'}}>Report an Issue</span>
          </Link>

          </div>

        </div>

      </div>
    </Grid>
    </div>
		);
	}
}
export default Resources;
